import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const modules = (() => {
	/**
	 * Add store module in the /store directory and it will automatically
	 * read it and load it with the name of the file as the module name.
	 * The crypto-heavy cache/solana/swap modules are registered just after
	 * the first application frame so they do not block the homepage shell.
	 */
	const requireState = require.context(
		'@/store',
		false,
		/(?<!index)(?<!cache)(?<!solana)(?<!swap)\.js$/
	);
	let modules = {};

	requireState.keys().forEach((fileName) => {
		const moduleName = fileName.split('/')[1].split('.')[0];
		const module = requireState(fileName).default;

		modules = {
			...modules,
			[moduleName]: module,
		};
	});

	return modules;
})();

const store = new Vuex.Store({
	modules,
	getters: {
		tokenPrice: (state) => (mint) => {
			const tp = state.cache?.tokenPrices?.[mint.toString()];
			// console.log("Looking for", mint.toString(), tp)
			if (!tp || Date.now() - tp.updatedAt > 60_000) return null;

			return tp.price;
		},
	},
});

let heavyModulesPromise = null;

export function ensureHeavyStoreModules() {
	if (heavyModulesPromise) return heavyModulesPromise;

	heavyModulesPromise = Promise.all([
		import(/* webpackChunkName: "legacy-cache" */ './cache'),
		import(/* webpackChunkName: "legacy-solana" */ './solana'),
		import(/* webpackChunkName: "legacy-swap" */ './swap'),
	]).then(([cache, solana, swap]) => {
		const heavyModules = {
			cache: cache.default,
			solana: solana.default,
			swap: swap.default,
		};

		Object.entries(heavyModules).forEach(([name, module]) => {
			if (!store.hasModule(name)) store.registerModule(name, module);
		});
	});

	return heavyModulesPromise;
}

export default store;
